module.exports = __webpack_public_path__ + "static/img/IMG_20240820_200328.2e8b2d31.jpg";